<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">
        <div style="margin-right: 30px;">
          通知标题
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.title"></a-input>
        </div>
        <div>
          发送状态
          <a-select class="inp ml24" v-model:value="query.status">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="1">已发送</a-select-option>
            <a-select-option value="0">草稿</a-select-option>
          </a-select>
        </div>

        <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
      </div>
      <div class="search-r">
        <a-button @click="showAddModal" type="primary">+ 发送通知</a-button>
        <a-button class="ml24" @click="delMore" type="primary"><i class="iconfont icon-shanchuanniu mr5"></i>批量删除</a-button>
      </div>
    </div>

    <!-- 管理端 -->
    <a-table 
      :columns="columns" 
      :row-key="(record) => record.id" 
      :data-source="dataSource" 
      size="middle" 
      class="mt23" 
      :pagination="pagination" 
      :scroll="{ y: 'auto' }" 
      v-autoHeight="{ extraHeight: 88, trHeight: 47 }"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
    >
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'ranking'">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template v-if="column.key === 'sendScope'">
          {{ record.sendScope === 'all' ? '全部企业' : '指定企业' }}
        </template>
        <template v-if="column.key === 'createTime'">
          {{ formatDate(record.createTime) }}
        </template>
        <template v-if="column.key === 'status'">
          <a-tag :color="record.status === '1' ? 'green' : 'orange'">
            {{ record.status === '1' ? '已发送' : '草稿' }}
          </a-tag>
        </template>
        <template v-if="column.key === 'readStatus'">
          <div v-if="record.totalTargetCount > 0" class="read-status-info">
            <span v-if="record.totalTargetCount === record.readCount" class="all-read">
              <CheckCircleOutlined style="color: #52c41a; margin-right: 4px;" /> 全部已读
            </span>
            <span v-else class="not-all-read">
              已读 {{ record.readCount }}/{{ record.totalTargetCount }}
            </span>
          </div>
          <span v-else>-</span>
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a class="ml10" @click="showReadStatus(record)">查看已读状态</a>
            <a class="ml10" @click="handleDelete(record.id)">删除</a>
          </span>
        </template>
      </template>
    </a-table>

    <!-- 发送通知弹窗 -->
    <a-modal
        v-model:visible="addModalVisible"
        title="发送通知"
        @cancel="handleCancelAdd"
        :width="800"
        :footer="null"
    >
      <a-form
          ref="addFormRef"
          :model="addFormData"
          layout="vertical"
          :rules="addFormRules"
      >
        <!-- 通知标题 -->
        <a-form-item label="消息模版" name="title">
          <a-input
              v-model:value="addFormData.title"
              placeholder="请输入通知标题"
              :maxLength="100"
              showCount
          />
        </a-form-item>

        <!-- 通知内容 -->
        <a-form-item label="通知内容" name="content">
          <a-textarea
              v-model:value="addFormData.content"
              placeholder="请输入通知内容"
              :rows="8"
              :maxLength="2000"
              showCount
          />
        </a-form-item>

        <!-- 发送范围 -->
        <a-form-item label="发送范围" name="sendScope">
          <a-radio-group v-model:value="addFormData.sendScope">
            <a-radio value="all">全部企业</a-radio>
            <a-radio value="specific">指定企业</a-radio>
          </a-radio-group>
        </a-form-item>

        <!-- 企业选择器（仅在指定企业时显示） -->
        <a-form-item v-if="addFormData.sendScope === 'specific'" label="选择企业" name="selectedCompanies">
          <a-select
              v-model:value="addFormData.selectedCompanies"
              mode="multiple"
              placeholder="请选择要发送的企业"
              :options="enterpriseOptions"
              :filter-option="filterEnterpriseOption"
              style="width: 100%"
              @focus="loadEnterpriseList"
          />
        </a-form-item>

        <!-- 发送状态 -->
        <a-form-item label="发送状态" name="status">
          <a-radio-group v-model:value="addFormData.status">
            <a-radio value="1">立即发送</a-radio>
            <a-radio value="0">保存为草稿</a-radio>
          </a-radio-group>
        </a-form-item>

        <!-- 自定义底部按钮 -->
        <div style="text-align: right; padding-top: 16px">
          <a-button @click="handleCancelAdd">取消</a-button>
          <a-button type="primary" @click="handleSubmitAdd" style="margin-left: 8px">确认</a-button>
        </div>
      </a-form>
    </a-modal>

    <!-- 已读状态弹窗 -->
    <a-modal
        v-model:visible="readStatusModalVisible"
        title="企业已读状态"
        @cancel="handleCancelReadStatus"
        :width="900"
    >
      <div class="read-status-container">
        <div class="read-status-summary">
          <div class="summary-item">
            <span class="label">企业总数：</span>
            <span class="value">{{ totalCompanies }}</span>
          </div>
          <div class="summary-item">
            <span class="label">已读数量：</span>
            <span class="value read-count">{{ readCount }}</span>
          </div>
          <div class="summary-item">
            <span class="label">未读数量：</span>
            <span class="value unread-count">{{ unreadCount }}</span>
          </div>
          <div class="summary-item">
            <span class="label">已读率：</span>
            <span class="value">{{ readRate }}%</span>
          </div>
        </div>

        <a-table
            :columns="readStatusColumns"
            :data-source="companyReadStatusList"
            :pagination="readStatusPagination"
            :row-key="record => record.id"
            @change="handleReadStatusTableChange"
        >
          <template #bodyCell="{ column, record }">
            <!-- 已读状态列 -->
            <template v-if="column.key === 'readStatus'">
              <a-tag :color="record.readStatus === '1' ? 'green' : 'red'">
                {{ record.readStatus === '1' ? '已读' : '未读' }}
              </a-tag>
            </template>
            <!-- 已读时间列 -->
            <template v-if="column.key === 'readTime'">
              {{ record.readTime || '-' }}
            </template>
          </template>
        </a-table>
      </div>
    </a-modal>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { message, Modal } from 'ant-design-vue';
import { CheckCircleOutlined } from '@ant-design/icons-vue';
import { getList as getEnterpriseList } from '@/api/enterprise/index.js';
import { getPagesByCondition, add, del } from '@/api/announcement/index.js';

const router = useRouter();

// 表格列配置
const columns = [
  {
    title: "序号",
    key: "ranking",
    width: 90
  },
  {
    title: "通知模版",
    dataIndex: "title",
    key: "title",
    ellipsis: true,
  },
  {
    title: "通知内容",
    dataIndex: "content",
    key: "content",
    ellipsis: true,
  },
  {
    title: "发送范围",
    key: "sendScope",
    width: 120,
  },
  {
    title: "发送时间",
    key: "createTime",
    width: 180,
  },
  {
    title: "状态",
    key: "status",
    width: 80,
  },
  {
    title: "已读状态",
    key: "readStatus",
    width: 120,
  },
  {
    title: "操作",
    key: "action",
    width: 160,
  },
];

// 已读状态表格列配置
const readStatusColumns = [
  {
    title: "企业名称",
    dataIndex: "companyName",
    key: "companyName",
  },
  {
    title: "联系人",
    dataIndex: "contactPerson",
    key: "contactPerson",
    width: 100,
  },
  {
    title: "联系电话",
    dataIndex: "contactPhone",
    key: "contactPhone",
    width: 120,
  },
  {
    title: "已读状态",
    key: "readStatus",
    width: 120,
  },
  {
    title: "已读时间",
    key: "readTime",
    width: 180,
  },
];

// 查询参数
const query = reactive({
  title: '',
  status: '',
});

// 数据列表
let dataSource = ref([]);

// 分页配置
const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 10,
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"],
  showTotal: (total) => `共有 ${total} 条数据`,
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize),
  onChange: pageChange,
  showSizeChange: pageSizeChange,
});

// 多选数据
const selectedRowKeys = ref([]);

// 新增通知弹窗
const addModalVisible = ref(false);
const addFormRef = ref();
const addFormData = reactive({
  title: '',
  content: '',
  sendScope: 'all', // 'all' 表示全部企业，'specific' 表示指定企业
  selectedCompanies: [],
  status: '1', // 1表示立即发送，0表示草稿
});

// 企业选择器选项
const enterpriseOptions = ref([]);
const enterpriseListLoading = ref(false);

// 已读状态弹窗
const readStatusModalVisible = ref(false);
const currentNoticeId = ref(null);
const companyReadStatusList = ref([]);
const readStatusPagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0,
});

// 已读状态统计
const totalCompanies = ref(0);
const readCount = ref(0);
const unreadCount = computed(() => totalCompanies.value - readCount.value);
const readRate = computed(() => {
  if (totalCompanies.value === 0) return 0;
  return Math.round((readCount.value / totalCompanies.value) * 100);
});

// 表单验证规则
const addFormRules = {
  title: [
    { required: true, message: '请输入通知标题', trigger: 'blur' },
    { max: 100, message: '标题长度不能超过100个字符', trigger: 'blur' },
  ],
  content: [
    { required: true, message: '请输入通知内容', trigger: 'blur' },
    { max: 2000, message: '内容长度不能超过2000个字符', trigger: 'blur' },
  ],
  selectedCompanies: [
    {
      required: () => addFormData.sendScope === 'specific',
      message: '请选择要发送的企业',
      trigger: 'change',
    },
  ],
};

// 分页切换
function pageChange(page, pageSize) {
  pagination.current = page;
  getData();
}

// 每页数量变更
function pageSizeChange(current, size) {
  pagination.pageSize = size;
  getData();
}

// 加载通知列表
const getData = async () => {
  try {
    const data = {
      pageIndex: pagination.current,
      pageSize: pagination.pageSize,
      conditionMap: { ...query },
    };
    
    const res = await getPagesByCondition(data);
    if (res.code === 200) {
      // 获取原始数据
      const rawData = res.data.records || [];
      
      // 为每条数据添加已读状态统计信息
      dataSource.value = await Promise.all(rawData.map(async (item) => {
        // 模拟获取已读状态统计信息
        const readStats = await getReadStatistics(item.id);
        return {
          ...item,
          // 实际项目中这些数据应由后端API返回
          readCount: readStats.readCount || 0,
          totalTargetCount: readStats.totalTargetCount || 0
        };
      }));
      
      pagination.total = res.data.total;
    } else {
      message.error('获取通知列表失败');
    }
  } catch (error) {
    message.error('获取通知列表出错');
    console.error('获取通知列表出错:', error);
  }
};

// 获取通知的已读统计信息
const getReadStatistics = async (noticeId) => {
  try {
    // 实际项目中应该调用专门的API来获取已读统计信息
    // 这里使用模拟数据
    
    // 如果是发送给全部企业
    let totalTargetCount = 0;
    let readCount = 0;
    
    // 获取企业总数作为模拟数据
    const enterpriseRes = await getEnterpriseList({ pageIndex: 1, pageSize: 1 });
    if (enterpriseRes.code === 200) {
      totalTargetCount = enterpriseRes.data.total || 100; // 假设企业总数为后端返回的总数或默认100
      // 随机生成已读数量（模拟数据）
      readCount = Math.floor(Math.random() * (totalTargetCount + 1));
    }
    
    return {
      readCount,
      totalTargetCount
    };
  } catch (error) {
    console.error('获取已读统计信息出错:', error);
    return {
      readCount: 0,
      totalTargetCount: 0
    };
  }
};

// 加载企业列表（用于选择器）
const loadEnterpriseList = async () => {
  if (enterpriseOptions.value.length > 0 || enterpriseListLoading.value) {
    return;
  }

  enterpriseListLoading.value = true;
  try {
    const params = {
      pageIndex: 1,
      pageSize: 1000,
    };

    const res = await getEnterpriseList(params);
    if (res.code === 200) {
      enterpriseOptions.value = (res.data.records || []).map(item => ({
        label: item.companyName,
        value: item.id,
        contactPerson: item.contactPerson,
        contactPhone: item.contactPhone,
      }));
    } else {
      message.error('获取企业列表失败');
    }
  } catch (error) {
    message.error('获取企业列表出错');
    console.error('获取企业列表出错:', error);
  } finally {
    enterpriseListLoading.value = false;
  }
};

// 搜索
const search = () => {
  pagination.current = 1;
  getData();
};

// 重置
const reset = () => {
  query.title = '';
  query.status = '';
  pagination.current = 1;
  getData();
};

// 多选变更
const onSelectChange = (value) => {
  selectedRowKeys.value = value;
};

// 显示新增通知弹窗
const showAddModal = () => {
  addModalVisible.value = true;
  // 重置表单
  if (addFormRef.value) {
    addFormRef.value.resetFields();
  }
  addFormData.title = '';
  addFormData.content = '';
  addFormData.sendScope = 'all';
  addFormData.selectedCompanies = [];
  addFormData.status = '1';
};

// 取消新增通知
const handleCancelAdd = () => {
  addModalVisible.value = false;
};

// 提交新增通知
const handleSubmitAdd = async () => {
  if (!addFormRef.value) return;

  try {
    await addFormRef.value.validate();

    // 构建提交数据
    const submitData = {
      title: addFormData.title,
      content: addFormData.content,
      status: addFormData.status,
      // 根据实际API要求添加其他字段
      sendScope: addFormData.sendScope,
      targetCompanies: addFormData.sendScope === 'specific' ? addFormData.selectedCompanies : [],
    };

    const res = await add(submitData);
    if (res.code === 200) {
      message.success('通知发送成功');
      addModalVisible.value = false;
      getData();
    } else {
      message.error('通知发送失败');
    }
  } catch (error) {
    if (error?.message) {
      message.error(error.message);
    } else {
      message.error('通知发送出错');
      console.error('通知发送出错:', error);
    }
  }
};

// 显示已读状态弹窗
const showReadStatus = (record) => {
  currentNoticeId.value = record.id;
  readStatusModalVisible.value = true;
  readStatusPagination.current = 1;
  loadCompanyReadStatus();
};

// 加载企业已读状态
const loadCompanyReadStatus = async () => {
  try {
    // 这里模拟获取企业已读状态数据
    const params = {
      pageIndex: readStatusPagination.current,
      pageSize: readStatusPagination.pageSize,
    };

    const res = await getEnterpriseList(params);
    if (res.code === 200) {
      // 模拟已读状态数据
      const companies = res.data.records || [];
      companyReadStatusList.value = companies.map(company => ({
        id: company.id,
        companyName: company.companyName,
        contactPerson: company.contactPerson,
        contactPhone: company.contactPhone,
        readStatus: Math.random() > 0.5 ? '1' : '0', // 模拟随机已读未读状态
        readTime: Math.random() > 0.5 ? new Date().toLocaleString() : null, // 模拟已读时间
      }));

      readStatusPagination.total = res.data.total || 0;
      totalCompanies.value = res.data.total || 0;

      // 计算已读数量
      readCount.value = companyReadStatusList.value.filter(item => item.readStatus === '1').length;
    } else {
      message.error('获取企业已读状态失败');
    }
  } catch (error) {
    message.error('获取企业已读状态出错');
    console.error('获取企业已读状态出错:', error);
  }
};

// 已读状态表格分页变化
const handleReadStatusTableChange = (paginationObj) => {
  readStatusPagination.current = paginationObj.current;
  readStatusPagination.pageSize = paginationObj.pageSize;
  loadCompanyReadStatus();
};

// 取消查看已读状态
const handleCancelReadStatus = () => {
  readStatusModalVisible.value = false;
};

// 删除通知
const handleDelete = (id) => {
  Modal.confirm({
    title: '确认删除',
    content: '确定要删除这条通知吗？',
    okText: '确认',
    cancelText: '取消',
    onOk: async () => {
      try {
        const res = await del(id);
        if (res.code === 200) {
          message.success('删除成功');
          getData();
        } else {
          message.error('删除失败');
        }
      } catch (error) {
        message.error('删除出错');
        console.error('删除出错:', error);
      }
    },
  });
};

// 批量删除
const delMore = () => {
  if (selectedRowKeys.value.length < 1) {
    message.warning("请选中要删除的数据！");
    return false;
  } else {
    Modal.confirm({
      title: '确认批量删除，该操作不可逆?',
      onOk() {
        // 实际项目中应调用批量删除接口
        Promise.all(selectedRowKeys.value.map(id => del(id)))
            .then(results => {
              const allSuccess = results.every(res => res.code === 200);
              if (allSuccess) {
                message.success("批量删除成功");
                getData();
                selectedRowKeys.value = [];
              } else {
                message.error("批量删除失败");
              }
            })
            .catch(error => {
              message.error("批量删除出错");
              console.error('批量删除出错:', error);
            });
      },
      onCancel() { },
    });
  }
};

// 企业选择器过滤方法
const filterEnterpriseOption = (input, option) => {
  return (
      option.label.toLowerCase().includes(input.toLowerCase()) ||
      option.value.toLowerCase().includes(input.toLowerCase())
  );
};

// 格式化日期
const formatDate = (dateString) => {
  if (!dateString) return '';
  // 实际项目中可以使用moment或其他日期处理库
  return new Date(dateString).toLocaleString();
};

// 初始加载
onMounted(() => {
  getData();
});
</script>

<style lang="less" scoped>
.inp {
  width: 13.5vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
  }

  .search-r {
    display: flex;
  }
}

/deep/.ant-input::placeholder {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #68767E;
}

/deep/.ant-select-selector {
  background-color: #F2F4F7 !important;
  color: #68767E !important;
}

.main {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(10, 33, 46, 1);
  background-color: rgba(239, 240, 245, 1);
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}

a {
  color: #1E8EF2;
}

.read-status-container {
  padding: 8px 0;
}

.read-status-summary {
  display: flex;
  margin-bottom: 16px;
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.summary-item {
  margin-right: 32px;
}

.summary-item .label {
  margin-right: 8px;
  color: rgba(0, 0, 0, 0.65);
}

.summary-item .value {
  font-weight: 500;
}

.read-count {
  color: #52c41a;
}

.unread-count {
  color: #ff4d4f;
}
</style>